/* z-index must live on the Positioner — it is the positioned ancestor; the
 * Popup is static so z-index alone would be ignored. Without this, the
 * tooltip could render behind app-sidebar / drawer surfaces in the same
 * stacking context. */
.positioner {
  z-index: var(--tuna-zIndex-tooltip);
}

.tooltip {
  background-color: var(--tuna-palette-grey-700);
  color: var(--tuna-palette-grey-50);
  border-radius: var(--tuna-shape-radius-sm);
  padding: 4px 8px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: 0.6875rem;
  font-weight: 500;
  max-width: 300px;
  word-wrap: break-word;
}
